module.exports = __webpack_public_path__ + "static/media/rest.ea85d7b0.jpg";